/**
 * The listing-card grid, in one place.
 *
 * Saved, Dismissed and Browse all render the same square image cards, and
 * they should stay the same size as each other -- two pages that disagree
 * about card width look like one of them is broken.
 *
 * A fixed column count makes desktop cards huge on a wide monitor, since
 * `Layout` puts no max-width on the page and a small fixed number of columns
 * across a wide screen means very big images. The column count climbs with
 * the viewport here instead.
 *
 * ONE COLUMN ON A PHONE. A first pass made it two on the reasoning that
 * browsing merch is a scanning task and 2-up covers twice the ground per
 * scroll. Matt tried it and the opposite turned out to be true: with two cards
 * side by side he did not actually look at either one while scrolling past.
 * Covering more ground is worthless if none of it registers. One card at a
 * time, filling the width, is the whole point on a phone -- so do not
 * "optimize" this back.
 *
 * The desktop ladder is unchanged from what it has been since the previews were
 * first made smaller: a 1440px screen shows 5 across.
 */
export const CARD_GRID =
  "grid gap-3 sm:gap-4 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6";
